import { render, staticRenderFns } from "./approver_show.vue?vue&type=template&id=419b5c38&scoped=true&"
import script from "./approver_show.vue?vue&type=script&lang=js&"
export * from "./approver_show.vue?vue&type=script&lang=js&"
import style0 from "./approver_show.vue?vue&type=style&index=0&id=419b5c38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419b5c38",
  null
  
)

export default component.exports